export const SQUARE_FRAME_MAX_PX = 760;
export const SQUARE_FRAME_MIN_PX = 280;
export const DESKTOP_HORIZONTAL_RESERVE = 96;
export const MOBILE_HORIZONTAL_GUTTER = 32;
export const VERTICAL_RESERVE = 132;
export const MOBILE_BREAKPOINT = 1024;

export function computeSquareFramePx(
  canvasWidth: number,
  canvasHeight: number,
  mobile = canvasWidth < MOBILE_BREAKPOINT,
): number {
  const horizontal = mobile ? MOBILE_HORIZONTAL_GUTTER : DESKTOP_HORIZONTAL_RESERVE;
  return Math.max(
    SQUARE_FRAME_MIN_PX,
    Math.floor(
      Math.min(
        SQUARE_FRAME_MAX_PX,
        canvasWidth - horizontal,
        canvasHeight - VERTICAL_RESERVE,
      ),
    ),
  );
}
